import {FormProvider, useForm} from 'react-hook-form';
import {Navigate, useLocation, useNavigate} from 'react-router';

import FormError from 'components/form/Error';
import FormSubmit from 'components/form/Submit';
import FormText from 'components/form/Text';
import {handleSubmitErrors} from 'components/form/utils';
import useAppContext from 'conf/AppContext';
import {useAuth} from 'context/AuthContext';

export default function MfaPage() {
  const appContext = useAppContext();
  const location = useLocation();
  const navigate = useNavigate();
  const userId = location.state;
  const {isAuthenticated} = useAuth();

  const formMethods = useForm({
    defaultValues: {
      userId: userId ?? '',
      qrCode1: '',
      qrCode2: '',
      qrCode3: '',
      qrCode4: '',
      qrCode5: '',
      qrCode6: '',
    },
  });

  if (isAuthenticated) {
    return location?.state?.from?.pathname
      ? <Navigate to={location.state.from.pathname} replace={true} />
      : <Navigate to="/" replace={true} />;
  }

  const {handleSubmit, setError} = formMethods;

  const onSubmit = async (values) => {
    const {userId, qrCode1, qrCode2, qrCode3, qrCode4, qrCode5, qrCode6} = values;
    try {
      const rez = await appContext.api.post('api/v1/users/verify/qrcode', {
        json: {
          userId,
          qrCode: `${qrCode1}${qrCode2}${qrCode3}${qrCode4}${qrCode5}${qrCode6}`,
        },
        parseJson: true,
      });
      localStorage.setItem('login', 'true');
      navigate('/');
    } catch (err) {
      await handleSubmitErrors(appContext, err, setError);
    }
  };

  return (
    <div className="container mtb">
      <div className="row justify-content-center">
        <div className="col-lg-5 text-center" style={{marginTop: '150px'}}>
          <a href="index.html">
            <img src="assets/img/svg/logo.svg" alt="" />
          </a>
          <div className="card mt-5">
            <div className="card-body">
              <h3 className="text-light text-center mb-5">2-Step Verification</h3>
              <h4 className="text-light text-center">Please enter QR code</h4>

              <FormProvider {...formMethods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="row mt-4 pt-2">
                    <FormText label="" name="userId" required={true} type="hidden" />
                    <div className="col">
                      <FormText label="" name="qrCode1" required={true} maxLength={1} />
                    </div>
                    <div className="col">
                      <FormText label="" name="qrCode2" required={true} maxLength={1} />
                    </div>
                    <div className="col">
                      <FormText label="" name="qrCode3" required={true} maxLength={1} />
                    </div>
                    <div className="col">
                      <FormText label="" name="qrCode4" required={true} maxLength={1} />
                    </div>
                    <div className="col">
                      <FormText label="" name="qrCode5" required={true} maxLength={1} />
                    </div>
                    <div className="col">
                      <FormText label="" name="qrCode6" required={true} maxLength={1} />
                    </div>
                  </div>
                  <div className="text-end col mt-5">
                    <FormError />
                    <FormSubmit key="save" className="btn btn-lg btn-outline-light bg-black text-white">Continue</FormSubmit>
                  </div>
                </form>
              </FormProvider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
